import React from 'react';
import { Trans } from 'react-i18next';

import FigoLottie from '../../../common/FigoLottie';

import './FileClaimbotEvie.css';

const FileClaimbotEvie = ({
  agentImage = '',
  agentText = '',
  loading = true,
}) => {
  if (loading) {
    return <FigoLottie />;
  }

  return (
    <div className="File-claimbot-evie">
      <img alt="" src={agentImage} />

      <div className="File-claimbot-evie-bubble-message">
        <Trans
          components={{
            // href/text are injected by Trans from agentText
            /* eslint-disable jsx-a11y/anchor-is-valid */
            /* eslint-disable jsx-a11y/anchor-has-content */
            a: <a rel="noopener noreferrer" target="_blank" />,
            /* eslint-enable jsx-a11y/anchor-is-valid */
            /* eslint-enable jsx-a11y/anchor-has-content */
            b: <b />,
          }}
          defaults={agentText}
          parent="span"
        />
      </div>
    </div>
  );
};
export { FileClaimbotEvie };
